module.exports = __webpack_public_path__ + "static/media/image01.d8ac22e4.png";